// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"121":"gallery","548":"calendar"}[chunkId] + "-legacy." + {"121":"eef21c15","548":"6b9c7ce3"}[chunkId] + ".js";
};